import clsx from 'clsx';
import FormInput from '../../../components/forms/FormInput';
import Star from '../../../components/decoration/Star';
import { Button } from '../../../components/buttons/Button';
import CatCharacter from '../../../components/characters/CatCharacter';
import { useAuth } from '../../../lib/auth';
import RootLayout from '../../layouts/RootLayout';
import Alert from '../../../components/Alert';
import { useState } from 'react';
import VsimavecHead from '../../../assets/vsimavec-head.svg';
import { useFormik } from 'formik';
import { Link, useSearchParams } from 'react-router';
import UrlTriggeredAlert from '../../containers/UrlTriggeredAlert';

function StarsDecoration() {
    return (
        <>
            <Star
                className={clsx(
                    'absolute',
                    'opacity-10',
                    'top-0',
                    '-ml-28 -mt-28'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-20',
                    'left-0 top-0',
                    '-mt-14 ml-28'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-30',
                    'left-0 top-0',
                    '-ml-10 -mt-10'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-70',
                    'left-0 top-0',
                    '-ml-20 mt-12'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-100',
                    'left-0 top-0',
                    '-ml-5 mt-36'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-25',
                    'bottom-0 left-0',
                    '-ml-16 mb-20'
                )}
            />
            <Star
                className={clsx(
                    'absolute',
                    'opacity-70',
                    'bottom-0',
                    '-mb-16 -ml-48'
                )}
            />
        </>
    );
}

export default function LoginPage() {
    const [searchParams] = useSearchParams();

    const { login } = useAuth({
        middleware: 'guest',
        redirectTo: '/dashboard' + (searchParams.has('ref') ? '?ref=' + searchParams.get('ref') : ''),
        tmp: 'LoginPage',
    });

    const [loginError, setLoginError] = useState<boolean | string>(false);

    const {
        handleSubmit,
        handleChange,
        values,
        errors,
        touched,
        setSubmitting,
        isSubmitting,
    } = useFormik({
        initialValues: { email: '', password: '' },
        onSubmit: (values) => {
            login({ values, setError: setLoginError }).finally(() =>
                setSubmitting(false)
            );
        },
    });

    return (
        <RootLayout>
            {/*<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT ?? ''}>*/}
            <main className="flex h-screen items-center md:py-52">
                <div
                    className={clsx(
                        'flex h-full flex-col justify-center',
                        'mx-auto max-w-2xl',
                        'px-4 sm:px-8 md:px-10 md:pr-28',
                        'w-full md:w-2/3 lg:w-1/2'
                    )}
                >
                    <UrlTriggeredAlert />
                    <div className={clsx('block md:hidden', 'mb-auto mt-0')}>
                        <div className="my-8 flex items-center">
                            <img
                                src={VsimavecHead}
                                height="42"
                                className="mr-4 h-[42px]"
                                alt="Všímavec"
                            />
                            <span className="font-display text-[20px] font-bold">
                                Všímavec
                            </span>
                        </div>
                    </div>

                    <div className="flex h-full flex-col justify-center">
                        <h1>Vítej!</h1>
                        <p className="mb-6 text-ink-800">
                            Je dobře, že jsi zpátky.
                        </p>
                        <div className="flex flex-col space-y-3">
                            {/*<ButtonGoogleLogin />*/}

                            {/*<p*/}
                            {/*    className={clsx(*/}
                            {/*        'flex items-center py-8 text-ink-800',*/}
                            {/*        'before:h-[1px] before:flex-[1_1_0%] before:bg-gradient-to-r before:from-gray-200',*/}
                            {/*        'after:h-[1px] after:flex-[1_1_0%] after:bg-gradient-to-l after:from-gray-200'*/}
                            {/*    )}*/}
                            {/*>*/}
                            {/*    Nebo*/}
                            {/*</p>*/}

                            <form
                                onSubmit={handleSubmit}
                                className="flex flex-col gap-y-6"
                            >
                                {loginError && (
                                    <Alert type="error">{loginError}</Alert>
                                )}

                                <FormInput
                                    name="email"
                                    label="E-mail"
                                    onChange={handleChange}
                                    value={values.email}
                                    type="email"
                                    tabIndex={1}
                                    error={
                                        errors.email && touched.email
                                            ? errors.email
                                            : null
                                    }
                                />

                                <FormInput
                                    name="password"
                                    label="Heslo"
                                    onChange={handleChange}
                                    value={values.password}
                                    type="password"
                                    tabIndex={2}
                                    labelChildren={
                                        <Link
                                            to="/zapomenute-heslo"
                                            className="border-b border-blue-500 text-blue-500"
                                            tabIndex={4}
                                        >
                                            Resetovat heslo
                                        </Link>
                                    }
                                />

                                <Button
                                    type="submit"
                                    color="product"
                                    className="mt-3 text-base"
                                    loadingText="Probíhá přihlašování"
                                    isLoading={isSubmitting}
                                    tabIndex={3}
                                >
                                    Přihlásit se
                                </Button>
                            </form>

                            <p
                                className={clsx(
                                    'py-8 text-center text-ink-800'
                                )}
                            >
                                Nemáte účet?{' '}
                                <Link
                                    to="/registrace"
                                    className="border-b border-blue-500 text-blue-500"
                                >
                                    {/*Přejděte na registraci školy*/}
                                    Vyzkoušejte zkušební verzi aplikace zdarma
                                </Link>
                            </p>

                            {/*<Button>*/}
                            {/*    <FaEnvelope size={22} className="me-3" />*/}
                            {/*    Přihlásit se pomocí e-mailu*/}
                            {/*</Button>*/}
                        </div>
                    </div>
                </div>
                <div
                    className={clsx(
                        'h-full',
                        'hidden md:block md:w-1/3 lg:w-1/2'
                    )}
                >
                    <div className="relative flex h-full w-full items-center justify-center rounded-l-3xl bg-product-100">
                        <div className="-mt-24 box-content h-full overflow-hidden pb-24">
                            <CatCharacter className="h-[150%]" />
                        </div>
                        <div className="absolute bottom-0 h-2/5 w-full rounded-bl-3xl bg-gradient-to-t from-product-100" />
                        <>
                            <StarsDecoration />
                        </>
                    </div>
                </div>
            </main>
            {/*</GoogleOAuthProvider>*/}
        </RootLayout>
    );
}
